import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/pro-light-svg-icons'

import { Link } from '@domain-group/suit-theme'

import AuthenticatedDownload from '@components/AuthenticatedDownload'

import useSmsLog from '@hooks/useSmsLog'

import { SmsLogModel } from '@domain-group/realhub-backend-api-types'

const Actions = (props: { smsLog: SmsLogModel }) => {
  const { smsLog } = props

  const { urls: { exportSmsLog } } = useSmsLog(smsLog)

  return (
    <AuthenticatedDownload>
      <Link greyLink href={exportSmsLog}>
        <FontAwesomeIcon icon={faDownload} />
      </Link>
    </AuthenticatedDownload>
  )
}

export default Actions
